import { AxiosResponse } from "axios";
import { SET_TAGS, SET_TAG, SET_ERRORMSG } from "@/store/mutation-types";
import {
  CLEAR_TAG_ISLOADING,
  DELETE_TAG,
  EDIT_TAG,
  GET_TAGS,
  REGISTER_TAG,
} from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import Tag from "@/services/tag";
import { Module } from "vuex";
import { EditTag, RegisterTag, GetTag } from "@/dtos/Tag.dto";

const tag: Module<any, {}> = {
  state: {
    tag: {
      data: null,
      isLoading: false,
    },
    tags: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    tag: (state: { tag: any }) => state.tag,
    tags: (state: { tags: any }) => state.tags,
  },
  mutations: {
    [SET_TAG]: (
      state: { tag: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.tag.data = payload.data;
      state.tag.isLoading = payload.isLoading;
    },
    [SET_TAGS]: (
      state: { tags: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.tags.data = payload.data;
      state.tags.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_TAG]: async ({ commit }: any, payload: any) => {
      commit(SET_TAG, { data: null, isLoading: true });

      const result: AxiosResponse = await Tag.registerTag(payload as RegisterTag);

      if (result) {
        if (result.data.status) {
          commit(SET_TAG, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_TAG, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_TAG, { isLoading: false });
        return false;
      }
    },
    [GET_TAGS]: async ({ commit }: any, payload: any) => {
      commit(SET_TAGS, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await Tag.getTags(payload as GetTag);

        if (result) {
          if (result.data.status) {
            commit(SET_TAGS, { data: result.data.data, isLoading: false });
            return true;
          }
          commit(SET_TAGS, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_TAGS, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_TAGS, { data: null, isLoading: false });
        if (error?.code !== "ECONNABORTED") {
          commit(SET_ERRORMSG, "Failed to fetch tags");
        }
        return false;
      }
    },
    [EDIT_TAG]: async ({ commit }: any, payload: any) => {
      commit(SET_TAG, { data: null, isLoading: true });

      const result: AxiosResponse = await Tag.editTag(payload as EditTag);

      if (result) {
        if (result.data.status) {
          commit(SET_TAG, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_TAG, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_TAG, { isLoading: false });
        return false;
      }
    },
    [DELETE_TAG]: async ({ commit }: any, payload: string) => {
      commit(SET_TAG, { data: { id: payload }, isLoading: true });

      const result: AxiosResponse = await Tag.deleteTag(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_TAG, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_TAG, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_TAG, { isLoading: false });
        return false;
      }
    },
    [CLEAR_TAG_ISLOADING]: ({ commit }) => {
      commit(SET_TAG, { isLoading: false });
      commit(SET_TAGS, { isLoading: false });
    },
  },
};

export default tag;
